import React from "react";
import ReactPaginate from "react-paginate";

/**
 * Pagination Component
 * 
 * Displays pagination controls using react-paginate library
 * Shows current page info and page number navigation
 * 
 * @param {Object} props - Component props
 * @param {number} props.currentPage - Current page number (0-based for react-paginate)
 * @param {number} props.totalPages - Total number of pages
 * @param {number} props.totalCount - Total number of images
 * @param {boolean} props.loading - Whether page navigation is loading
 * @param {Function} props.onPageChange - Function to handle page change
 * @param {number} props.currentCount - Number of images currently displayed
 * 
 * @returns {JSX.Element} Pagination controls UI
 */
const Pagination = ({
  currentPage,
  totalPages,
  totalCount,
  loading,
  onPageChange,
  currentCount
}) => {
  if (totalCount <= 0 || totalPages <= 1) return null;

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1; // Convert from 0-based to 1-based
    onPageChange(selectedPage);
  };

  return (
    <div className="pagination-container">
      <div className="pagination-info">
      </div>
      
      <ReactPaginate
        breakLabel="..."
        nextLabel="→"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={totalPages}
        previousLabel="←"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1} // Convert to 0-based for react-paginate
        containerClassName="react-paginate"
        pageClassName="paginate-page"
        pageLinkClassName="paginate-link"
        previousClassName="paginate-previous"
        previousLinkClassName="paginate-link"
        nextClassName="paginate-next"
        nextLinkClassName="paginate-link"
        breakClassName="paginate-break"
        breakLinkClassName="paginate-link"
        activeClassName="paginate-active"
        disabledClassName="paginate-disabled"
      />
    </div>
  );
};

export default Pagination;
